package com.xtream.composeapp.platform

enum class PlatformType { ANDROID, DESKTOP, IOS, WEB }
expect val currentPlatform: PlatformType